var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"id":"feedback-button","pill":"","variant":"primary","disabled":this.feedbackFormUrl == null},on:{"click":_vm.openFeedbackForm}},[_vm._v("Submit feedback")])}
var staticRenderFns = []

export { render, staticRenderFns }